export type VectroResourceType =
        | 'dashboard'
        | 'users'
        | 'orders'
        | 'pricingPolicies'
        | 'limitPolicies'
        | 'scenarios'
        | 'rateTypes'
        | 'campaigns'
        | 'vouchers'
        | 'contracts'
        | 'vehicles'
        | 'customers'
        | 'parkingSessions'
        | 'gateMonitor'
        | 'gates'
        | 'tariffs'
        | 'reports';

export const VectroResource: Record<VectroResourceType, VectroResourceType> = {
        dashboard: 'dashboard',
        users: 'users',
        orders: 'orders',
        pricingPolicies: 'pricingPolicies',
        limitPolicies: 'limitPolicies',
        scenarios: 'scenarios',
        rateTypes: 'rateTypes',
        campaigns: 'campaigns',
        vouchers: 'vouchers',
        contracts: 'contracts',
        vehicles: 'vehicles',
        customers: 'customers',
        parkingSessions: 'parkingSessions',
        gateMonitor: 'gateMonitor',
        gates: 'gates',
        tariffs: 'tariffs',
        reports: 'reports'
};
